module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/tony-robbins-4eb107a46e3f70ff912ef1b5129a0419.png";